import {
  CHANGE_EXPENSES_HEAD_STATUS_REQUEST,
  CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST,
  FETCH_EXPENSES_HEADS_REQUEST,
  FETCH_EXPENSES_SUBHEADS_REQUEST,
  SAVE_EXPENSES_HEAD_REQUEST,
  SAVE_EXPENSES_SUBHEAD_REQUEST,
  FETCH_EXPENSES_MAPPED_HEADS_REQUEST,
  FETCH_EXPENSES_MAPPED_HEADS_SUCCESS,
  FETCH_EXPENSES_MAPPED_HEADS_FAILURE,
  FETCH_MAPPED_HEADS_REQUEST,
  SAVE_MAPPED_HEAD_REQUEST,
  CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  FETCH_EXPENSE_ENTRY_REQUEST,
  SAVE_EXPENSE_ENTRY_REQUEST,
  FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST,
  CHANGE_EXPENSES_ENTRY_STATUS_REQUEST,
  FETCH_EXPENSE_ENTRY_REPORT_REQUEST,
  FETCH_EXPENSES_APPROVAL_LISTS_REQUEST,
  FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS,
  FETCH_EXPENSES_APPROVAL_LISTS_FAILURE,
  SAVE_EXPENSES_APPROVAL_LISTS_REQUEST,
  FETCH_EXPENSES_HEADS_GRID_REQUEST,
  FETCH_EXPENSES_HEADS_GRID_SUCCESS,
  FETCH_EXPENSES_HEADS_GRID_FAILURE
} from './actionTypes';

export const fetchExpensesHeads = (unit_id) => ({
  type: FETCH_EXPENSES_HEADS_REQUEST,
  payload: { unit_id }
});

export const saveExpensesHead = (payload) => ({
  type: SAVE_EXPENSES_HEAD_REQUEST,
  payload,
});

export const changeExpensesHeadStatus = (payload) => ({
  type: CHANGE_EXPENSES_HEAD_STATUS_REQUEST,
  payload,
});

// Fetch Subheads
export const fetchExpensesSubheads = (unit_id) => ({
  type: FETCH_EXPENSES_SUBHEADS_REQUEST,
  payload: { unit_id },
});

// Save Subhead
export const saveExpensesSubhead = (payload) => ({
  type: SAVE_EXPENSES_SUBHEAD_REQUEST,
  payload,
});

// Change Subhead Status
export const changeExpensesSubheadStatus = (payload) => ({
  type: CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST,
  payload,
});

export const fetchExpensesMappedheads = (unit_id, head_id) => ({
  type: FETCH_EXPENSES_MAPPED_HEADS_REQUEST,
  payload: { unit_id, head_id },
});

export const fetchExpensesMappedheadsSuccess = (data) => ({
  type: FETCH_EXPENSES_MAPPED_HEADS_SUCCESS,
  payload: data,
});

export const fetchExpensesMappedheadsFailure = (error) => ({
  type: FETCH_EXPENSES_MAPPED_HEADS_FAILURE,
  payload: error,
});

export const fetchExpensesMappedHeads = (unit_id) => ({
  type: FETCH_MAPPED_HEADS_REQUEST,
  payload: { unit_id }
});

export const saveExpensesMappedHead = (payload) => ({
  type: SAVE_MAPPED_HEAD_REQUEST,
  payload,
});

export const changeExpensesMappedHeadStatus = (payload) => ({
  type: CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  payload,
});

// GET EXPENSE ENTRY
export const fetchExpenseEntry = (unit_id) => ({
  type: FETCH_EXPENSE_ENTRY_REQUEST,
  payload: { unit_id },
});

// SAVE EXPENSE ENTRY
export const saveExpenseEntry = (payload) => ({
  type: SAVE_EXPENSE_ENTRY_REQUEST,
  payload,
});

export const fetchExpensesEntryMappedHeads = (unit_id, head_id) => ({
  type: FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST,
  payload: { unit_id, head_id },
});

export const changeExpensesEntryStatus = (payload) => ({
  type: CHANGE_EXPENSES_ENTRY_STATUS_REQUEST,
  payload,
});

export const fetchExpenseEntryReport = (payload) => ({
  type: FETCH_EXPENSE_ENTRY_REPORT_REQUEST,
  payload,
});

export const fetchExpensesApprovalLists = (unit_id) => ({
  type: FETCH_EXPENSES_APPROVAL_LISTS_REQUEST,
  payload: { unit_id },
});

export const fetchExpensesApprovalListsSuccess = (data) => ({
  type: FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS,
  payload: data,
});

export const fetchExpensesApprovalListsFailure = (error) => ({
  type: FETCH_EXPENSES_APPROVAL_LISTS_FAILURE,
  payload: error,
});

export const saveExpensesApprovalLists = (payload) => ({
  type: SAVE_EXPENSES_APPROVAL_LISTS_REQUEST,
  payload,
});

export const fetchExpensesMappedGridheads = (unit_id) => ({
  type: FETCH_EXPENSES_HEADS_GRID_REQUEST,
  payload: { unit_id },
});

export const fetchExpensesMappedGridheadsSuccess = (data) => ({
  type: FETCH_EXPENSES_HEADS_GRID_SUCCESS,
  payload: data,
});

export const fetchExpensesMappedGridheadsFailure = (error) => ({
  type: FETCH_EXPENSES_HEADS_GRID_FAILURE,
  payload: error,
});